<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Almoxarifado/ Entrada de NFes </label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <!--<v-btn
            color="info"
            to="/entradaNF/criar"
            v-if="isAllowed(1)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>-->
          <v-btn
            color="info"
            @click="selecionar()"
            v-if="isAllowed(20)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="entradasNF.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="entradasNF.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              :max="new Date().toISOString().substr(0, 10)"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :custom-filter="filter"
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por pÃ¡gina',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.dataEmissao="{ item }">
          <span>{{
            new Date(item.dataEmissao).toLocaleDateString("pt-BR")
          }}</span>
        </template>
        <template v-slot:item.dataCriacao="{ item }">
          <span>{{
            new Date(item.dataCriacao)
              .toLocaleString()
              .replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
        <template v-slot:item.cnpj="{ item }">
          {{ formatCurrency(item.cnpj) }}
        </template>
        <template v-slot:item.idPedido="{ item }">
          <div v-if="pedidosEntradaNF(item).length > 0" class="d-flex flex-column">
            <a
              v-for="pedido in pedidosEntradaNF(item)"
              :key="`${pedido.tipoPedido}-${pedido.idPedido}`"
              href="#"
              class="text--primary font-weight-medium text-decoration-underline"
              @click.prevent="abrirPdfPedido(pedido)"
            >
              {{ textoPedido(pedido) }}
            </a>
          </div>
          <span v-else>-</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(20)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
          <v-tooltip v-if="isInactive(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="inativar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Inativar</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data="{ item }">
          <span>{{
            new Date(item.data).toLocaleString().replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="showModalFornecedor" max-width="100%">
      <v-card>
        <v-card-title class="headline"
          >Selecionar Fornecedor/Pedido</v-card-title
        >

        <v-card-text class="pt-0">
          <fornecedor
            :itens="pedidosEntrada"
            :showModal="showModalFornecedor"
            @adicionar="onAdicionarFornecedor"
          />
        </v-card-text>

        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModalFornecedor = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { canInactivateModule, getUserRoles } from "@/services/loginService";
import { getPdf } from "../../../services/entradaNFService";
import { getPdf as getPedidoPdf } from "../../../services/pedidoService";
import { getPdf as getPedidoAvulsoPdf } from "../../../services/pedidoAvulsoService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import moment from "moment";
import Fornecedor from "./Fornecedor.vue";
import { saveAs } from "file-saver";

export default {
  name: "listaNF",
  data() {
    return {
      idModulo: 11,
      selectedFilter: "0",
      loading: false,
      search: "",
      showAtivo: false,
      apenasLeitura: false,
      showModalFornecedor: false,
      active_tab: 2,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      arrayEvents: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "Pedido", value: "idPedido" },
        { text: "Data Lançamento", align: "start", value: "dataCriacao" },
        { text: "Nota Fiscal", value: "numero" },
        { text: "Data Emissão", value: "dataEmissao" },
        { text: "Fornecedor", value: "fornecedor" },
        { text: "CNPJ", value: "cnpj" },
        { text: "Unidade", value: "unidadeAdm" },
        { text: "Responsável", value: "usuario" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false, width: "18%" },
      ],

      filters: {
        id: [],
        idMapaCotacao: [],
        dataCriacao: [],
        fornecedor: [],
        empresa: [],
        comprador: [],
        centroCusto: [],
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
    };
  },
  computed: {
    ...mapState("entradaNF", ["entradasNF"]),
    ...mapState("pedido", ["pedidosEntrada"]),
    ...mapState("fornecedor", ["fornecedores"]),
    ...mapState("local", ["locais"]),
    filteredList() {
      const searchLower = this.search.toLowerCase();

      return this.entradasNF
        .filter((e) => {
          // 1. Filtro por texto digitado
          const buscaTexto =
            e.id.toString().toLowerCase().includes(searchLower) ||
            this.textoPedidosEntrada(e).toLowerCase().includes(searchLower) ||
            (e.fornecedor || "").toLowerCase().includes(searchLower) ||
            (e.numero || "").toLowerCase().includes(searchLower) ||
            (e.unidadeAdm || "").toLowerCase().includes(searchLower) ||
            e.itens.some(
              (i) =>
                i.idSolicitacaoItem?.toLowerCase().includes(searchLower) ||
                i.produto?.toLowerCase().includes(searchLower) ||
                i.centroCusto?.toLowerCase().includes(searchLower)
            );

          // 2. Filtro por data (se datas forem preenchidas)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(p.dataCriacao.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              new Date(p.dataCriacao.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]));

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (f === "data") {
              const dataFormatada = new Date(r[f])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
              return this.filters[f].includes(dataFormatada);
            }

            if (f === "centroCusto") {
              return e.produtos.some((e) =>
                this.filters[f].includes(e.centroCusto)
              );
            }

            return this.filters[f].includes(e[f]);
          });

          // 4. Filtro por status (se nÃ£o for "0")
          const statusOk =
            this.selectedFilter === "0" || e.status === this.selectedFilter;

          return buscaTexto && dataValida && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },

    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("entradaNF", [
      "atualizarEntradasNF",
      "atualizarEntradaNF",
      "atualizarPedidosNF",
    ]),
    ...mapActions("pedido", ["atualizarPedidosEntrada"]),
    ...mapActions("fornecedor", [
      "atualizarFornecedores",
      "atualizarFornecedor",
    ]),
    ...mapActions("centroCusto", ["atualizarCentrosCusto"]),
    ...mapActions("condicaoPagamento", ["atualizarCondicoes"]),
    ...mapActions("local", ["atualizarLocais"]),

    columnValueList(val) {
      if (val == "data") {
        return this.entradasNF.map((d) =>
          new Date(d[val]).toLocaleString().replace(/(.*)\D\d+/, "$1")
        );
      } else {
        return this.entradasNF.map((d) => d[val]);
      }
    },
    editar(item) {
      this.atualizarEntradaNF(item);
      
      if (this.isAllowed(20)) {
        this.$router.push({
          path: "/entradaNF/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/entradaNF/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    inativar(item) {
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarEntradasNF();
      this.loading = false;
      if (!this.fornecedores || this.fornecedores.length == 0) {
        await this.atualizarFornecedores();
      }
      await this.atualizarPedidosEntrada();
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    isInactive(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return canInactivateModule(id) || (regra != null && regra.inativar);
    },
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
    selecionar: function (e) {
      this.showModalFornecedor = true;
    },
    onAdicionarFornecedor(payload) {
      // payload = { tipo: 'pedido'|'produtos', fornecedorId, pedidoId, itens: [...] }
      // envie para quem precisa / atualize seu estado:
      // ex: this.$emit('selecionar-itens', payload)
      // ou: this.itensSelecionados.push(...payload.itens)

      // feche a modal

      console.log(JSON.stringify(payload));
      if (payload.tipo == "pedido" || payload.tipo == "produtos") {
        this.atualizarPedidosNF(payload);
      }
      this.atualizarFornecedor(this.findFornecedor(payload.fornecedorId));
      this.showModalFornecedor = false;
      this.$router.push(`/entradaNF/criar`);
    },

    findFornecedor(fornecedorId) {
      return this.fornecedores.find((f) => f.id === fornecedorId);
    },
    doAjax() {
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.centrosCusto || this.centrosCusto.length == 0) {
        this.atualizarCentrosCusto();
      }
      this.atualizarCondicoes();
    },
    formatCurrency(valor) {
      if (valor.length === 14) {
        return valor.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      } else {
        return valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
    },
    show(item) {
      getPdf(item.id, abrirJanelaPdf());
    },
    tipoPedidoValor(tipoPedido) {
      if (tipoPedido === 1 || tipoPedido === "1" || tipoPedido === "PC") return 1;
      if (tipoPedido === 2 || tipoPedido === "2" || tipoPedido === "PA") return 2;
      return null;
    },
    pedidosEntradaNF(item) {
      if (Array.isArray(item.pedidos)) {
        return item.pedidos.filter((pedido) => pedido.idPedido && this.tipoPedidoValor(pedido.tipoPedido));
      }
      if (item.idPedido) {
        return [{ idPedido: item.idPedido, tipoPedido: item.tipoPedido }].filter((pedido) => this.tipoPedidoValor(pedido.tipoPedido));
      }
      return [];
    },
    textoPedido(pedido) {
      const tipo = this.tipoPedidoValor(pedido.tipoPedido);
      const numero = pedido.numeroPedido || pedido.idPedido;
      return tipo === 2 ? `${numero}` : `${numero}`;
    },
    textoPedidosEntrada(item) {
      return this.pedidosEntradaNF(item).map((pedido) => this.textoPedido(pedido)).join(" ");
    },
    abrirPdfPedido(pedido) {
      const tipo = this.tipoPedidoValor(pedido.tipoPedido);
      if (tipo === 1) {
        getPedidoPdf(pedido.idPedido, abrirJanelaPdf());
      }
      if (tipo === 2) {
        getPedidoAvulsoPdf(pedido.idPedido, abrirJanelaPdf());
      }
    },
    baixarlista() {
      const blob = this.gerarExcel();
      const nome_arquivo = "entradasNF.xlsx";
      saveAs(blob, nome_arquivo);
    },
    gerarExcel() {
      const colunas = [
        { chave: "dataCriacao", cabecalho: "Data LanÃ§amento" },
        { chave: "pedidos", cabecalho: "Pedido" },
        { chave: "numero", cabecalho: "Nota Fiscal" },
        { chave: "dataEmissao", cabecalho: "Data EmissÃ£o" },
        { chave: "fornecedor", cabecalho: "Fornecedor" },
        { chave: "cnpj", cabecalho: "CNPJ" },
        { chave: "unidadeAdm", cabecalho: "Unidade Adm" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "dataCriacao" || c.chave === "dataEmissao") {
              return new Date(item[c.chave])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
            } else if (c.chave === "numero") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else if (c.chave === "pedidos") {
              return this.textoPedidosEntrada(item);
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col, i) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(col.chave === "pedidos" ? this.textoPedidosEntrada(d) : d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    this.obterLista();
    this.doAjax();
    this.atualizarPedidosNF(null);
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
  components: {
    Fornecedor,
  },
};
</script>


